import { render, staticRenderFns } from "./ExpartiateFile.vue?vue&type=template&id=233ec90a&scoped=true"
import script from "./ExpartiateFile.vue?vue&type=script&lang=js"
export * from "./ExpartiateFile.vue?vue&type=script&lang=js"
import style0 from "./ExpartiateFile.vue?vue&type=style&index=0&id=233ec90a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ec90a",
  null
  
)

export default component.exports